import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import remarkBreaks from 'remark-breaks';
// GFM adds tables, strikethrough, task lists and autolinks. Pinned to ^1 on
// purpose: react-markdown@6 sits on the CJS unified-9 line, and remark-gfm@2+
// is ESM-only — installing it would break markdown everywhere, including the
// 2,417 existing question explanations. If react-markdown is ever upgraded to
// 8+, this pin must move with it.
import remarkGfm from 'remark-gfm';
import rehypeKatex from 'rehype-katex';
import 'katex/contrib/mhchem/mhchem.js';

interface MarkdownRendererProps {
  children: string;
  className?: string;
  inline?: boolean;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ children, className, inline }) => {
  if (!children) return null;

  const md = (
    <ReactMarkdown
      remarkPlugins={[remarkMath, remarkGfm, remarkBreaks]}
      rehypePlugins={[rehypeKatex]}
    >
      {children}
    </ReactMarkdown>
  );

  if (inline) {
    return <span className={className || 'inline-markdown'}>{md}</span>;
  }

  return className ? <div className={className}>{md}</div> : md;
};

export default MarkdownRenderer;
